import { useQueryClient } from 'react-query';

import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteRecruitmentFilter = () => {
  const queryClient = useQueryClient();
  return useDelete({
    url: ApiRoutesEnum.recruitmentsDeleteFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.recruitmentsFilters]);
    },
  });
};
